/**
 * Bulk edit configuration for Users.
 *
 * Unlike unit/hanwha (which render the generic BulkEditModal from these
 * definitions), the user bulk UI is custom: BulkEditWizardModal mirrors the
 * user wizard steps (info / tenants / permissions / cameras) with the same
 * controls and order. The fields listed here only seed the formData keys
 * that useBulkEdit initializes to null (null = untouched).
 *
 * Semantics (mirrors user/edit in the wizard):
 * - Booleans travel as "1"/"0" strings (wizard switches use value/unchecked-value).
 * - List fields (master_tenant, tenant, type_alarm, app_modules) REPLACE the
 *   whole list of each user. Empty arrays count as untouched.
 * - The alarm history block sends the three fields together (chosen mode has
 *   the value, the others are 0), like the wizard does.
 * - The permissions tree is excluded: it derives from the profile and
 *   user/edit does not send it either.
 * - allowed_units_live_video_flows is excluded: it is hidden in the wizard
 *   (v-show="false" in GeneralInfoStep).
 */
export const BULK_EDIT_FIELDS = [
  // Step 1: info (GeneralInfoStep order)
  { key: "id_country" },
  { key: "allowed_tabs" },
  { key: "vpn_access" },
  { key: "video_wall" },
  { key: "enabled_chat" },
  { key: "enabled_helpdesk" },
  { key: "active" },
  { key: "alarm_history_per_hours" },
  { key: "alarm_history_per_days" },
  { key: "alarm_history_by_records" },
  // Step 2: tenants (TenantStep order)
  { key: "master_tenant" },
  { key: "tenant" },
  { key: "type_alarm" },
  // Step 3: permissions (PermissionStep order)
  { key: "id_profile" },
  { key: "app_modules" },
];

export const BULK_EDIT_ENDPOINT = "v1/user/bulk-update";

// GET endpoint for batch status polling ({endpoint}/{batch_id}).
export const BULK_EDIT_BATCH_STATUS_ENDPOINT = "v1/user/batches";

// Ids array key in the bulk-update payload. Backend expects
// { id_users: [...], filters: {...}, data: {...} } for manual selection.
export const BULK_EDIT_IDS_KEY = "id_users";
